import { ROUTES } from '@dashboard/router/routeNames'

export default [
  {
    path: 'offers',
    children: [
      {
        name: ROUTES.OFFERS,
        path: '',
        component: () => import('@dashboard/modules/offer/pages/OffersIndex.vue'),
        meta: {
          title: 'Offers',
          description: `Offers are the things that you want to promote to your website visitors.`,
          rightyPrompts: [
            // {
            //   label: 'Create an offer',
            //   prompt: 'Help me create a new offer or CTA. I want to drive visitors to take a specific action.'
            // },
            {
              label: 'Conversion leaders',
              drawerLabel: 'Which offers convert best?',
              prompt:
                'Which offers have the best conversion rates? What makes them successful and how can I apply those learnings to other offers?'
            },
            {
              label: 'CTA optimization',
              drawerLabel: 'How can I improve my CTAs?',
              prompt:
                'Review my offers and suggest improvements to button text, headlines, and descriptions that could improve conversions.'
            }
          ]
        }
      },
      {
        name: ROUTES.CREATEOFFER,
        path: 'new',
        component: () => import('@dashboard/modules/offer/pages/OfferNew.vue'),
        props: { forms: false },
        meta: { title: 'New offer' }
      },
      {
        name: ROUTES.OFFER,
        path: ':offerId',
        component: () => import('@dashboard/modules/offer/pages/OfferShow.vue'),
        props: true,
        meta: {
          rightyPrompts: [
            {
              label: 'Optimize this offer',
              drawerLabel: 'How can I improve this offer?',
              prompt:
                'Help me improve the content for {{offerId}}. Review the headline, description, and button text for clarity and persuasiveness.'
            },
            {
              label: 'How is this performing?',
              drawerLabel: 'Show me how this offer is performing',
              prompt:
                'How is {{offerId}} performing? Show me the conversion rates, where it appears, and how it compares to my other offers.'
            }
            // {
            //   label: 'Test ideas',
            //   prompt: 'Suggest A/B test ideas for this offer. What variations in copy, design, or placement could improve conversions?'
            // }
          ]
        }
      }
    ]
  },
  {
    path: 'forms',
    children: [
      {
        name: ROUTES.FORMS,
        path: '',
        component: () => import('@dashboard/modules/offer/pages/FormsIndex.vue'),
        meta: {
          title: 'Forms',
          description: `These are forms that you can use to turn your website visitors into leads.`,
          rightyPrompts: [
            // {
            //   label: 'Create a form',
            //   prompt: 'Help me create a new lead capture form. I want to collect visitor information and send it to my email platform.'
            // },
            {
              label: 'Reduce form friction',
              drawerLabel: 'How can I reduce form friction?',
              prompt: 'Review my forms and suggest which fields I can remove or simplify to improve completion rates.'
            }
          ]
        }
      },
      {
        name: ROUTES.CREATEFORM,
        path: 'new',
        component: () => import('@dashboard/modules/offer/pages/OfferNew.vue'),
        props: { forms: true },
        meta: { title: 'New form' }
      },
      {
        name: ROUTES.FORM,
        path: ':offerId',
        component: () => import('@dashboard/modules/offer/pages/OfferShow.vue'),
        props: true,
        meta: {
          rightyPrompts: [
            {
              label: 'Optimize this form',
              drawerLabel: 'How can I optimize this form?',
              prompt:
                'Help me improve the content for {{offerId}}. Review the form fields, headline, and button text for clarity and conversion optimization.'
            },
            {
              label: 'How is this performing?',
              drawerLabel: 'Show me how this form is performing',
              prompt:
                'How is {{offerId}} performing? Show me the opt-in rates, where it appears, and how it compares to my other forms.'
            },
            {
              label: 'Field analysis',
              drawerLabel: 'Analyze which fields I really need',
              prompt:
                'Analyze the form fields for this form. Which fields are necessary and which could be removed or made optional to reduce friction?'
            }
          ]
        }
      }
    ]
  }
]
